import {
  getGetTokensV6QueryOptions,
  useGetTokensV6,
  type GetTokensV6Params,
} from '@/lib/reservoir/reservoir.generated';
import { type ReservoirChain } from '@/utils/chains';
import { useMarketplaceChain } from './use-marketplace-chain';

export const COLLECTION_TOKEN_ITEMS_PER_PAGE = 20;

export const defaultParams: GetTokensV6Params = {
  includeAttributes: true,
  includeTopBid: true,
  includeQuantity: true,
  limit: COLLECTION_TOKEN_ITEMS_PER_PAGE,
  excludeSpam: true,
};

const getTokens = (
  chain: ReservoirChain,
  contractAddress: string,
  tokenIds: string[],
  override?: Partial<GetTokensV6Params>,
) => {
  return getGetTokensV6QueryOptions(
    { ...defaultParams, ...override, tokens: tokenIds.map(id => `${contractAddress}:${id}`) },
    {
      query: {
        queryKey: ['/tokens/v6', chain.id, contractAddress, defaultParams, override],
      },
      request: {
        baseURL: chain.reservoirBaseUrl,
        headers: {
          'x-api-key': chain.reservoirApiKey,
        },
      },
    },
  );
};

const useTokens = (tokens: string[], override?: Partial<GetTokensV6Params>) => {
  const chain = useMarketplaceChain();

  const request = useGetTokensV6(
    { ...defaultParams, ...override, tokens },
    {
      query: {
        queryKey: ['/tokens/v6', chain.id, tokens, defaultParams, override],
      },
      request: {
        baseURL: `${process.env.NEXT_PUBLIC_HOST_URL}${chain.proxyApi}`,
      },
    },
  );

  return request;
};

export { getTokens, useTokens };
